function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import AllhomesTabbedPanel from '@domain-group/fe-co-allhomes-tabbed-panel';
import { useSendEvent } from '@domain-group/fe-co-analytics';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import { DefaultListingCardV2, DefaultListingCardV2MapGQLProps } from '@domain-group/fe-co-allhomes-listing-card';
import { SearchQuery } from '@domain-group/fe-allhomes-search-api';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { Body, DisplaySmall, DisplayMedium } from '@domain-group/fe-blueprint-ui/typography';
import { Slider } from '@domain-group/fe-co-allhomes-shared-components';
import { useSendOnce } from '../../utils/use-send-once';
import * as styles from './cross-promotion.style';
import { useSimilarPropertiesForAddressQuery } from '../../queries/similar-properties.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var listingCardCarousel = _ref => {
  var _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    sendEvent = _ref.sendEvent;
  return ___EmotionJSX("div", {
    css: styles.listingCardCarousel
  }, ___EmotionJSX(Slider, {
    cards: listings.map(listing => {
      var _listing$listing$incl;
      return ___EmotionJSX("div", {
        css: styles.crossPromotedListingCard
      }, ___EmotionJSX(DefaultListingCardV2, _extends({
        css: styles.listingCard
      }, DefaultListingCardV2MapGQLProps(listing, {
        showNextInspection: true
      }), {
        appearance: "vertical",
        showAgencyBranding: (listing === null || listing === void 0 ? void 0 : (_listing$listing$incl = listing.listing.inclusions) === null || _listing$listing$incl === void 0 ? void 0 : _listing$listing$incl.brandingLevel) === 'PLATINUM',
        buttonComponent: ___EmotionJSX(AllhomesWatchlistButton, {
          noText: true,
          listingId: parseInt(String(listing.listing.id), 10)
        }),
        onClick: () => {
          sendEvent('similar-properties-listing-card-click', {
            inclusions: listing.listing.inclusions,
            refreshed: listing.listing.annotations.some(annotation => annotation.badge === 'refreshed')
          });
        }
      })));
    })
  }));
};
var buildSearchURL = (listingType, filters) => SearchQuery.fromQueryObject(listingType, filters).toSearchUrl();
var buildPanel = _ref2 => {
  var _queryResponse$queryO;
  var queryResponse = _ref2.queryResponse,
    listingType = _ref2.listingType,
    label = _ref2.label,
    linkLabel = _ref2.linkLabel,
    sendEvent = _ref2.sendEvent;
  return {
    tab: {
      label
    },
    content: ___EmotionJSX("div", {
      css: styles.contentPanel
    }, listingCardCarousel({
      listings: queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.similarProperties,
      sendEvent
    }), ___EmotionJSX("a", {
      css: styles.seeMoreLink,
      href: buildSearchURL(listingType.name, JSON.parse((_queryResponse$queryO = queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.queryObject) !== null && _queryResponse$queryO !== void 0 ? _queryResponse$queryO : '{}')),
      onClick: () => sendEvent('similar-properties-search-click')
    }, "See ", queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.totalMatched, " similar propert", (queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.totalMatched) === 1 ? 'y' : 'ies', " for ", linkLabel))
  };
};
export var CrossPromotion = _ref3 => {
  var _data$property, _data$property2;
  var property = _ref3.property,
    _ref3$options = _ref3.options,
    _ref3$options2 = _ref3$options === void 0 ? {} : _ref3$options,
    _ref3$options2$minRes = _ref3$options2.minResults,
    minResults = _ref3$options2$minRes === void 0 ? 5 : _ref3$options2$minRes,
    _ref3$options2$limit = _ref3$options2.limit,
    limit = _ref3$options2$limit === void 0 ? 5 : _ref3$options2$limit;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var variables = {
    streetAddressId: property.address.id,
    limit,
    minResults
  };
  var _useSimilarProperties = useSimilarPropertiesForAddressQuery({
      variables,
      ssr: false
    }),
    data = _useSimilarProperties.data,
    loading = _useSimilarProperties.loading;
  useSendOnce(loading, 'show-similar-properties');
  var similarSale = data === null || data === void 0 ? void 0 : (_data$property = data.property) === null || _data$property === void 0 ? void 0 : _data$property.similarSaleListings;
  var similarRental = data === null || data === void 0 ? void 0 : (_data$property2 = data.property) === null || _data$property2 === void 0 ? void 0 : _data$property2.similarRentalListings;
  useSendOnce(!loading, 'similar-properties-loaded', {
    saleTotalAttempts: similarSale === null || similarSale === void 0 ? void 0 : similarSale.totalAttempts,
    saleTotalDuration: similarSale === null || similarSale === void 0 ? void 0 : similarSale.totalDuration,
    saleTotalMatches: similarSale === null || similarSale === void 0 ? void 0 : similarSale.totalMatched,
    rentTotalAttempts: similarRental === null || similarRental === void 0 ? void 0 : similarRental.totalAttempts,
    rentTotalDuration: similarRental === null || similarRental === void 0 ? void 0 : similarRental.totalDuration,
    rentTotalMatches: similarRental === null || similarRental === void 0 ? void 0 : similarRental.totalMatched
  });
  var panels = [{
    queryResponse: similarSale,
    listingType: ListingType.SALES_RESIDENTIAL,
    label: 'Buy',
    linkLabel: 'sale'
  }, {
    queryResponse: similarRental,
    listingType: ListingType.RENTAL_RESIDENTIAL,
    label: 'Rent',
    linkLabel: 'rent'
  }];
  var content = () => ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AllhomesTabbedPanel, {
    panels: panels.map(panel => _objectSpread(_objectSpread({}, panel), {}, {
      sendEvent
    })).map(buildPanel),
    onTabClick: (_label, index) => {
      sendEvent('similar-properties-tab-click', {
        tab: panels[index].label
      });
    },
    tabAlignment: "centre"
  }));
  var HeadingText = mobile ? DisplaySmall : DisplayMedium;
  return ___EmotionJSX(Stack, {
    vertical: true,
    css: styles.crossPromotion
  }, ___EmotionJSX(HeadingText, {
    css: styles.heading
  }, "Similar properties to consider"), loading ? ___EmotionJSX(Stack, {
    vertical: true,
    gap: "m",
    horizontalAlign: "center"
  }, ___EmotionJSX(Body, {
    as: "p"
  }, "Finding similar properties..."), ___EmotionJSX(Loader, {
    css: styles.loader
  })) : content());
};